export default "__VITE_ASSET__cbe765ad__"